import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { LoaderModule } from "src/app/shared/loader/loader.module";
import { AutoCompleteSearchPipe } from "src/app/shared/pipes/auto-complete-search.pipe";
import { SharedModule } from "src/app/shared/shared.module";
import { IdnsRoutingModule } from "./idns-routing.module";
import { IdnsComponent } from "./idns.component";
import { AddIdnComponent } from './add-idn/add-idn.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    declarations: [
      IdnsComponent,
      AddIdnComponent,
      AutoCompleteSearchPipe
    ],
    imports: [
      MatAutocompleteModule,
      MatInputModule,
      CommonModule,
      IdnsRoutingModule,
      ReactiveFormsModule,
      FormsModule,
      NgbModule,
      LoaderModule,
      SharedModule
    ]
  })
  export class IdnsModule { }